<template>
  <div>
    <card
      :style="`height: ${height}px !important;`"
      id="chart"
      :showHr="false"
      class="home-card custom-shadow-card-header h-100"
    >
      <span>
        <div class="row">
          <div class="col-12">
            <div class="row mb-5">
              <div class="col-6 col-md-8">
                <img
                  class="chart-logo"
                  src="/static/img/iconos/icono-color-cajas.svg"
                />
                <span class="ml-2 custom-title"
                  ><strong>{{ $t('common_words.production') }}</strong></span
                >
              </div>
              <div class="col-6 col-md-4 text-right">
                <span class="custom-subtitle text-muted">{{
                  $t('production.boxes_summary')
                }}</span>
              </div>
            </div>
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </span>
      <div slot="footer" class="card-footer footer-date-at custom-opacity">
        <p class="text-white d-flex justify-content-between">
          <small class="ml-3">{{ $t('common_words.smart_cultivo') }}</small>
          <small class="mr-3">{{
            $t('common_words.last_fiftytwo_weeks')
          }}</small>
        </p>
      </div>
    </card>
  </div>
</template>

<script>
import axios from 'axios';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import MixinCharts from 'src/util/mixinCharts';
import drilldown from 'highcharts/modules/drilldown';
import i18n from 'src/i18n';

drilldown(Highcharts);
exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {},
    };
  },
  mixins: [MixinCharts],
  methods: {
    getBoxByFarmChartData() {
      return axios.get('/auth/boxes/indicators').then((response) => {
        response.data.height = `${this.height - 200}px`;
        this.chartOptions = this.barsWithDrilldown(
          response.data,
          0,
          false,
          i18n.t('production.boxes_quantity')
        );

        this.chartOptions.lang = {
          drillUpText: '< Volver a {series.name}',
        };
        this.chartOptions.drilldown.drillUpButton = {
          ...this.chartOptions.drilldown.drillUpButton,
          position: {
            relativeTo: 'series',
            y: 25,
            x: -3,
          },
        };
      });
    },
  },
  async created() {
    await this.getBoxByFarmChartData();
  },
  mounted() {},
};
</script>
